/* eslint-disable no-restricted-imports */

import { DS_HEIGHT } from '@calm/evexia-design-tokens';
import {
    Avatar as OgAvatar,
    AvatarProps as OgAvatarProps,
} from '@mui/material';
import { useMemo } from 'react';
import { sxAppend } from '../../sx';

export type AvatarProps = OgAvatarProps & {
    size?: 'xxsmall' | 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge';
    /**
     * Avatar shape. `rounded` uses the Figma DS radius
     * (`DS_SHAPE_BORDER_RADIUS.AVATAR_ROUNDED`); `circular` (default) and
     * `square` use MUI's defaults.
     */
    variant?: OgAvatarProps['variant'];
};
export const Avatar = ({ size, ...props }: AvatarProps) => {
    const sizePx = useMemo(() => {
        switch (size) {
            case 'xlarge':
                return DS_HEIGHT.AVATAR_XLARGE;
            case 'large':
                return DS_HEIGHT.AVATAR_LARGE;
            case 'medium':
                return DS_HEIGHT.AVATAR_MEDIUM;
            case 'xsmall':
                return DS_HEIGHT.AVATAR_XSMALL;
            case 'xxsmall':
                return DS_HEIGHT.AVATAR_XXSMALL;
            default:
                return DS_HEIGHT.AVATAR_SMALL;
        }
    }, [size]);
    return (
        <OgAvatar
            {...props}
            sx={sxAppend(
                {
                    fontSize: sizePx / 2,
                    height: sizePx,
                    width: sizePx,
                },
                props.sx
            )}
        />
    );
};
